export default __webpack_public_path__ + "static/media/Perth_GFloor.357fd389.jpg";